import { useEffect, useRef } from 'react';
import { useAppSelector } from 'store/hooks';
import { selectAppReconnecting } from 'features/application/applicationSlice';

export const useOnReconnected = (onReconnected: () => void) => {
  const isReconnecting = useAppSelector(selectAppReconnecting);
  const wasReconnecting = useRef(false);
  const callbackRef = useRef(onReconnected);
  callbackRef.current = onReconnected;

  useEffect(() => {
    const recovered = wasReconnecting.current && !isReconnecting;
    wasReconnecting.current = isReconnecting;
    if (recovered) {
      callbackRef.current();
    }
  }, [isReconnecting]);
};
